<template>
  <b-card class="status">
    <line-chart height="180"
                chartData=""
                option="">
    </line-chart>
  </b-card>
</template>

<script>
    import LineChart from "./line-chart";
    export default {
        name: "chart-status-vserver",
        components: {LineChart},
        computed:{},
        methods:{}
    }
</script>

<style scoped>
  .status{
    max-width: 440px;
    max-height: 353px;
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/chart-status-vserver.vue